/*
|--------------------------------------------------------------------------
| EaselDisplayObject
|--------------------------------------------------------------------------
|
| This mixin gives an Easel Vue component the required elements to be
| visible on the canvas.
|
*/

import EaselEventBinder from '../libs/easel-event-binder.js';
import easeljs from '../../easeljs/easel.js';
import normalizeAlignment from '../libs/normalize-alignment.js';

export default {
    inject: ['easel'],
    props: ['x', 'y', 'flip', 'rotation', 'scale', 'alpha', 'shadow', 'align'],
    data: function data() {
        return {
            component: null,
        };
    },
    watch: {
        x: function x() {
            if (this.component) {
                this.component.x = this.x || 0;
            }
        },
        y: function y() {
            if (this.component) {
                this.component.y = this.y || 0;
            }
        },
        flip: function flip() {
            if (this.component) {
                this.updateScales();
            }
        },
        scale: function scale() {
            if (this.component) {
                this.updateScales();
            }
        },
        rotation: function rotation() {
            if (this.component) {
                this.component.rotation = this.rotation;
            }
        },
        alpha: function alpha() {
            if (this.component) {
                this.updateAlpha();
            }
        },
        shadow: function shadow() {
            if (this.component) {
                this.updateShadow();
            }
        },
        align: function align() {
            if (this.component) {
                this.updateAlign();
            }
        },
    },
    mounted: function mounted() {
        this.init();
    },
    destroyed: function destroyed() {
        this.displayObjectBreakdown();
    },
    computed: {
        normalizedAlign: function normalizedAlign() {
            return normalizeAlignment(this.align || ['', '']);
        },
    },
    methods: {
        displayObjectInit: function displayObjectInit() {
            EaselEventBinder.bindEvents(this, this.component);
            this.component.x = this.x || 0;
            this.component.y = this.y || 0;
            this.component.rotation = this.rotation;
            this.updateScales();
            this.updateAlpha();
            this.updateShadow();
            this.updateAlign();
            this.easel.addChild(this);
        },
        displayObjectBreakdown: function displayObjectBreakdown() {
            this.easel.removeChild(this);
        },
        updateScales: function updateScales() {
            if (this.component) {
                var scale = this.scale || 1;
                this.component.scaleX = this.flip === 'horizontal' || this.flip === 'both' ? -scale : scale;
                this.component.scaleY = this.flip === 'vertical' || this.flip === 'both' ? -scale : scale;
            }
        },
        updateAlpha: function updateAlpha() {
            this.component.alpha = isNaN(this.alpha) || this.alpha === null ? 1 : this.alpha;
        },
        updateShadow: function updateShadow() {
            if (this.shadow) {
                this.component.shadow = new easeljs.Shadow(this.shadow[0], this.shadow[1], this.shadow[2], this.shadow[3]);
            } else {
                this.component.shadow = null;
            }
        },
        updateAlign: function updateAlign() {
            var this$1 = this;

            this.getBounds()
                .then(function (bounds) {
                    var w = bounds.width,
                        h = bounds.height,
                        hAlign = this$1.normalizedAlign[0] || 'left',
                        vAlign = this$1.normalizedAlign[1] || 'top';
                    if (hAlign === 'left') {
                        this$1.component.regX = 0;
                    } else if (hAlign === 'center') {
                        this$1.component.regX = w / 2;
                    } else if (hAlign === 'right') {
                        this$1.component.regX = w;
                    }
                    if (vAlign === 'top') {
                        this$1.component.regY = 0;
                    } else if (vAlign === 'center') {
                        this$1.component.regY = h / 2;
                    } else if (vAlign === 'bottom') {
                        this$1.component.regY = h;
                    }
                });
        },
        getBounds: function getBounds() {
            // Components should override this
            return Promise.reject('No bounds available');
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/EaselDisplayObject.js